export default "__VITE_ASSET__58beb809__"